import genetic from './genetic.svg';

// Каталог тримає і посилання на живий сайт, і на репозиторій — підпис
// виводиться з хоста, щоб кнопка не обіцяла демо там, де його немає.
const labelFor = (link) => {
	const host = new URL(link).hostname;
	if (/(^|\.)github\.com$/.test(host)) return 'View on GitHub';
	// Space — це запущений застосунок, а не сторінка проекту, тож підпис має
	// обіцяти рівно те, що людина отримає, натиснувши.
	if (/(^|\.)huggingface\.co$/.test(host)) return 'Try the live demo';
	return 'Open Site';
};

const BtnGitHub = ({ link }) => {
	return (
		<a href={link} target="_blank" rel="noreferrer" className="btn-outline">
			<img src={genetic} alt="" width="40px" />
			{labelFor(link)}
		</a>
	);
};

export default BtnGitHub;
